export const sidebarConstants = {
  CREATE_POST_POPUP: 'SIDEBAR/CREATE_POST_POPUP'
}
